import axios from 'axios';
import * as Sentry from '@sentry/react';

// Sends only 5xx and network errors (no error.response) to Sentry. 4xx are
// business responses (validation, 401, 403/409 rules), not bugs — not sent.
// Cancelled requests are not errors either. Always re-rejects the original
// error, so callers (handleAxiosError, 401 redirect, etc.) behave as before.
function onRejected(error) {
    if (!axios.isCancel(error)) {
        const status = error?.response?.status;
        if (!error?.response || status >= 500) {
            const method = error?.config?.method?.toUpperCase();
            const url = error?.config?.url;
            Sentry.captureException(error, {
                tags: { 'http.status': status ?? 'network' },
                extra: { method, url, status, code: error?.code },
            });
        }
    }
    return Promise.reject(error);
}

export function attachSentryInterceptor(instance) {
    instance.interceptors.response.use((response) => response, onRejected);
}
